export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12818.44950c75.jpg";